// Tutorial.js
import React, { useState, useEffect, useRef } from 'react';
import './Tutorial.css';

const Tutorial = ({ steps, onClose }) => {
	const [currentStep, setCurrentStep] = useState(0);
	const [highlightStyle, setHighlightStyle] = useState({});
	const tutorialContentRef = useRef(null);

	useEffect(
		() => {
			const updateHighlightStyle = () => {
				const element = document.querySelector(steps[currentStep].selector);
				if (element) {
					const rect = element.getBoundingClientRect();

					// Calculate position based on step's position option
					let topOffset = 0;
					switch (steps[currentStep].position) {
						case 'top':
							topOffset = rect.top + window.scrollY;
							break;
						case 'bottom':
							topOffset = rect.bottom + window.scrollY;
							break;
						// Add more cases as needed
						default:
							topOffset = rect.top + window.scrollY;
							break;
					}
					console.log(topOffset);
					setHighlightStyle({
						top: topOffset - 10,
						left: rect.left + window.scrollX - 10,
						width: rect.width + 20,
						height: rect.height + 20,
					});

					// Scroll to the element if it's not in view
					if (!isElementInViewport(element)) {
						element.scrollIntoView({ behavior: 'smooth', block: 'center' });
					}
				}
			};

			updateHighlightStyle();
			window.addEventListener('resize', updateHighlightStyle);
			return () => window.removeEventListener('resize', updateHighlightStyle);
		},
		[currentStep, steps]
	);

	const isElementInViewport = el => {
		const rect = el.getBoundingClientRect();
		return (
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <=
				(window.innerHeight || document.documentElement.clientHeight) &&
			rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	};

	const handleNext = () => {
		if (currentStep < steps.length - 1) {
			setCurrentStep(currentStep + 1);
		} else {
			onClose();
		}
	};

	const handlePrevious = () => {
		if (currentStep > 0) {
			setCurrentStep(currentStep - 1);
		}
	};

	return (
		<div className="tutorial-container">
			<div className="tutorial-overlay">
				<div className="tutorial-highlight" style={highlightStyle} />
			</div>
			<div
				className="tutorial-content"
				style={{
					top: highlightStyle.top + highlightStyle.height + 10,
					left: highlightStyle.left,
				}}
				ref={tutorialContentRef}
			>
				<p>{steps[currentStep].content}</p>
				<div className="tutorial-buttons">
					<button onClick={handlePrevious} disabled={currentStep === 0}>
						Previous
					</button>
					<button onClick={handleNext}>
						{currentStep === steps.length - 1 ? 'Finish' : 'Next'}
					</button>
				</div>
			</div>
		</div>
	);
};

export default Tutorial;
